module.exports = __webpack_public_path__ + "fonts/merriweather-v19-latin_latin-ext-700.0d66b1d7.woff";